<template>
  <div class="control-city">
    <div
      class="control-city-current"
      @click="$city.isCityHeaderShown = !$city.isCityHeaderShown"
    >
      {{ CITY.name }}
      <chevron-animated :reverse="$city.isCityHeaderShown" />
    </div>

    <div class="control-city-confirm">
      <ui-dropdown
        left
        right
        :visible="!CITY_CONFIRMED && !$city.isCityHeaderShown"
      >
        <p>
          Ваш регион доставки:
          <br>{{ CITY.name }}?
        </p>
        <div class="buttons">
          <ui-button
            text="Да, верно"
            @click="CONFIRM_CITY"
          />
          <ui-button
            flat
            text="Нет, выбрать другой"
            @click="$city.isCityHeaderShown = true"
          />
        </div>
      </ui-dropdown>
    </div>

    <div class="control-city-search">
      <ui-dropdown
        left
        @on-close="$city.isCityHeaderShown = false"
        :visible="$city.isCityHeaderShown"
      >
        <city-search
          @choose="chooseCity"
        />
      </ui-dropdown>
    </div>

    <vue-client-only>
      <template v-if="!adaptive.isDesktop">
        <modal-confirm
          :visible="!CITY_CONFIRMED && !$city.isCityHeaderShown"
          :title="`Ваш регион доставки: <br>${ CITY.name }?`"
          @on-close="CONFIRM_CITY"
          :buttons="[
            {
              text: 'Да, верно',
            // action дергается в close
            },
            {
              text: 'Нет, выбрать другой',
              flat: true,
              action: () => $f.showNav('city')
            }
          ]"
        />
      </template>
    </vue-client-only>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import VueClientOnly from 'vue-client-only';
import CitySearch from './city-search';
import ChevronAnimated from '../../assets/icons/chevron-animated';

export default {
  name: 'control-city',
  components: {
    ChevronAnimated,
    CitySearch,
    VueClientOnly,
  },
  inject: ['adaptive'],
  computed: {
    ...mapGetters({
      CITY: 'user/city',
      CITY_CONFIRMED: 'user/cityConfirmed',
    }),
  },

  mounted() {
    if (!this.CITY_CONFIRMED)
      this.DETECT_CITY();
  },

  methods: {
    ...mapActions({
      DETECT_CITY: 'user/detectCity',
      UPDATE_CITY: 'user/updateCity',
    }),

    ...mapMutations({
      CONFIRM_CITY: 'user/cityConfirmed',
    }),

    chooseCity(city) {
      this.$city.requestConfirmation({ city, reloadPage:true })
    },
  },
};
</script>

<style lang="scss">
.control-city {
  > * {
    display: none;
    &.modal {
      display: flex;
    }
  }
}

@include breakpoint("desktop") {
  .control-city {
    position: relative;
    margin-left: 33px;

    > * {
      display: block;
    }

    &-current {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 16px;
      padding: 7px;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;
        margin-left: 4px;
        color: $gray_lu;
      }
    }

    &-confirm,
    &-search {
      position: absolute;

      .ui-dropdown-content {
        padding: 24px;
      }
    }

    &-confirm {
      top: -21px;
      width: 320px;

      p {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
      }

      .buttons {
        display: flex;
        white-space: nowrap;

        > *:not(:first-child) {
          margin-left: 8px;
          flex: auto;
          width: auto;
        }
      }
    }

    &-search {
      top: 32px;
      left: -16px;

      .ui-dropdown-scrollview {
        overflow: auto;
        max-height: none;
      }
    }
  }
}
</style>
